export default __webpack_public_path__ + "static/media/complementary--go-left--g1.c3874410.png";